import React from 'react';
import SubmCard from '@/components/zoho/submissions/SubmCard';

export default function SubmGrid({ entities, pkField, nameField, onSelect, onApprove, onReject }) {
  if (!entities || entities.length === 0) {
    return (
      <div className="text-center py-16 text-muted-foreground" data-testid="subm-empty-grid">
        <p className="text-sm">No entities found matching your filters.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="subm-entity-grid">
      {entities.map(function(ent) {
        return (
          <SubmCard
            key={ent.primary_key}
            entity={ent}
            pkField={pkField}
            nameField={nameField}
            onSelect={onSelect}
            onApprove={onApprove}
            onReject={onReject}
          />
        );
      })}
    </div>
  );
}
